import React from 'react'

export default function CustomIcon({imageRef}: {imageRef: string}) {
    return (
        <img src={imageRef} alt="custom icon" width="100" height="100" />
    )
}




